<template>
  <div id="editor" class="editor"></div>
</template>

<script>
import storage from '../../service/utils/storage'
import E from 'wangeditor';
export default {
  name: 'editor',
  data() {
    return {
      editor: {},
      suffix: '',
    };
  },
  props: {
    desc: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.editInit();
  },
  components: {},
  methods: {
    editInit() {
      this.editor = new E('#editor');
      this.editor.config.menus = [
        'head', // 标题
        'justify', // 对齐方式
        'fontSize', // 字号
        'foreColor', // 文字颜色
        'bold', // 粗体
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'table', //表格
        'link', // 插入链接
        'image', // 插入图片
        'video', // 插入视频
      ];
      this.editor.config.colors = [
        '#000000',
        '#545c63',
        '#93999f',
        '#eeece0',
        '#1c487f',
        '#4d80bf',
        '#c24f4a',
        '#8baa4a',
        '#7b5ba1',
        '#46acc8',
        '#f9963b',
        '#ffffff',
      ];
      this.editor.config.pasteFilterStyle = false
      // this.editor.config.pasteTextHandle = (content) => {
      //   content = this.htmlDecodeByRegExp(content);
      //   this.editor.cmd.do('insertHTML', content);
      // };

      let uploadUrl = '';
       if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        uploadUrl = "api/platform/upload/uploadFile";
      } else {
        uploadUrl = "platform/upload/uploadFile";
      }
      this.editor.config.uploadImgServer = uploadUrl;
      this.editor.config.uploadFileName = 'image';
      this.editor.config.uploadImgHeaders = {
        timestamp: Date.now(),
        token: storage.get('headerToken'),
        version: '1.0.0',
        platform: 'pc',
      };
      //上传图片时可自定义传递一些参数
      this.editor.config.uploadImgParams = {
        img_type: 4,
        suffix: this.suffix,
      };
      const that = this;
      this.editor.config.uploadImgHooks = {
        before: function(xhr, editor, files) {
          if (
            !(
              files[0].type == 'image/jpeg' ||
              files[0].type == 'image/png' ||
              files[0].type == 'image/jpg' ||
              files[0].type == 'image/gif'
            )
          ) {
            that.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
            return false;
          }
          const suffix = files[0].name.substring(
            files[0].name.lastIndexOf('.')
          );
          that.suffix = suffix;
        },
        customInsert: function(insertImg, result, editor) {
          let url = result.data.path;
          JSON.stringify(url);
          let str = `<p style='text-align:center;margin:0px auto'>
          <img src='${url}' style='max-width:100%;height:auto;display:block;margin:0 auto;font-size:0px;border:none' /></p>`
          editor.cmd.do('insertHTML', str)
          // insertImg(url);
        },
      };
      this.editor.create();
    },
    //反转义
    htmlDecodeByRegExp(str) {
      let temp = '';
      if (str.length == 0) return '';
      temp = str.replace(/&amp;/g, '&');
      temp = temp.replace(/&lt;/g, '<');
      temp = temp.replace(/&gt;/g, '>');
      // temp = temp.replace(/&nbsp;/g, ' ');
      temp = temp.replace(/&#39;/g, "'");
      temp = temp.replace(/&quot;/g, '"');
      return temp;
    },
  },
};
</script>

<style lang='scss' scoped>
.editor {
  margin: 20px 0;
}
</style>
<style lang="scss">
.editor {
  .w-e-text-container {
    height: calc(
      100vh - 350px
    ) !important; /*!important是重点，因为原div是行内样式设置的高度300px*/
  }
  // img {
  //   max-width: 100%;
  //   height: auto;
  //   display: block;
  //   margin: 10px auto;
  // }
  video {
    max-width: 600px;
    height: auto;
    display: block;
    margin: 20px auto;
  }
}
</style>

